import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../../shared/LanguageService';
import CreateRegionModal from '../create/CreateRegionModal';
import EditRegionModal from '../edit/EditRegionModal';
import { Button } from 'react-bootstrap';
import * as Actions from '../actions/RegionActions';
import RegionList from './RegionList';
import IRegion from '../types/Region';
import notify from '../../../shared/feedback/notifications';
import { handleError } from '../../../shared/ErrorCatching';

class RegionsPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showCreateRegionModal: false,
            showEditRegionModal: false
        };

        this.createRegion = this.createRegion.bind(this);
        this.editRegion = this.editRegion.bind(this);
        this.deleteRegion = this.deleteRegion.bind(this);
        this.closeCreateRegionModal = this.closeCreateRegionModal.bind(this);
        this.closeEditRegionModal = this.closeEditRegionModal.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.loadRegions();
    }

    render() {
        return (
            <div>
                <h1>{Translate('regions/page/title/regions')}</h1>
                <div>
                    <Button
                        bsSize="large"
                        className="pull-right"
                        onClick={this.createRegion.bind(null)}
                        bsStyle="success"
                    >
                        {Translate('regions/page/button-label/create-region')}
                    </Button>
                </div>
                {this.renderModal()}
                <RegionList
                    items={this.props.regions}
                    onEdit={this.editRegion}
                    onDelete={this.deleteRegion}
                />
            </div>
        );
    }

    renderModal() {
        if (this.state.showCreateRegionModal) {
            return <CreateRegionModal closeModal={this.closeCreateRegionModal} />;
        }
        if (this.state.showEditRegionModal) {
            return (
                <EditRegionModal
                    regionId={this.state.regionId}
                    closeModal={this.closeEditRegionModal}
                />
            );
        }

        return null;
    }

    editRegion(value: IRegion) {
        this.setState({ regionId: value.id, showEditRegionModal: true });
    }

    createRegion() {
        this.setState({ showCreateRegionModal: true });
    }

    closeCreateRegionModal() {
        this.setState({ showCreateRegionModal: undefined });
    }

    closeEditRegionModal() {
        this.setState({ showEditRegionModal: undefined });
    }

    deleteRegion(value: IRegion) {
        this.props.actions.deleteRegion(value.id).catch((error: any) => handleError(error));
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        regions: state.regions.list
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            loadRegions: () => dispatch(Actions.loadRegions()),
            deleteRegion: (id: number) => dispatch(Actions.deleteRegion(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegionsPage);
